import $ from 'jquery';

export default function StuffType(vm) {
    this.all = function(params) {
        var url = '/stuff-type/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/stuff-type/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/stuff-type/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        url = '/stuff-type/delete/' + params.id;

        return vm.delete(url);
    };
}